"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var percentToDecimal = function (percent) { return (percent / 100).toFixed(3); };
var decimalToPercent = function (decimal) { return parseFloat(decimal) * 100; };
var Photo = /** @class */ (function () {
    function Photo(attrs) {
        this.attrs = attrs;
        this.id = attrs.id;
        this.publicId = attrs.publicId;
        this.version = attrs.version;
        this.width = attrs.width;
        this.height = attrs.height;
        this.transformation = attrs.transformation || {};
        this.crop = this.parseCropFromTransformation(this.transformation);
        this.angle = this.transformation.angle;
        this.showTooSmallWarning = false;
    }
    Photo.prototype.copy = function () {
        return new Photo(this.attrsWithUpdates);
    };
    Object.defineProperty(Photo.prototype, "attrsWithUpdates", {
        get: function () {
            return Object.assign(this.attrs, {
                transformation: this.userTransformation,
            });
        },
        enumerable: true,
        configurable: true
    });
    // Convert our db representation of transformations (in decimals)
    // to crop parameters in percentages
    Photo.prototype.parseCropFromTransformation = function (transform) {
        return {
            width: decimalToPercent(transform.width),
            height: decimalToPercent(transform.height),
            x: decimalToPercent(transform.x),
            y: decimalToPercent(transform.y),
        };
    };
    Object.defineProperty(Photo.prototype, "thumbUrl", {
        get: function () {
            var transformations = this.baseTransformations;
            Object.assign(transformations, {
                crop: 'thumb',
                gravity: 'south',
                width: 96,
                height: 96,
                format: 'jpg',
            });
            transformations.transformation = this.userTransformation;
            return this.signedUrl(this.publicId, transformations);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "fullUrl", {
        get: function () {
            var transformations = this.baseTransformations;
            Object.assign(transformations, this.limitSizeTransformation);
            transformations.transformation = this.userTransformation;
            return this.signedUrl(this.publicId, transformations);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "fullUrlWithoutCrop", {
        get: function () {
            var transformations = this.baseTransformations;
            Object.assign(transformations, this.limitSizeTransformation);
            transformations.transformation = this.angleTransformation;
            return this.signedUrl(this.publicId, transformations);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "baseTransformations", {
        get: function () {
            return {
                version: this.version,
                quality: 'auto:eco',
                flags: 'progressive',
                angle: 'exif',
                format: 'jpg',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "limitSizeTransformation", {
        get: function () {
            return {
                crop: 'limit',
                width: 600,
                height: 600,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "userTransformation", {
        get: function () {
            return Object.assign(this.cropTransformation, this.angleTransformation);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "cropTransformation", {
        get: function () {
            if (!this.isCropped) {
                return {};
            }
            return {
                width: percentToDecimal(this.crop.width),
                height: percentToDecimal(this.crop.height),
                x: percentToDecimal(this.crop.x),
                y: percentToDecimal(this.crop.y),
                crop: 'crop',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "angleTransformation", {
        get: function () {
            if (!this.angle) {
                return {};
            }
            return {
                angle: this.angle,
            };
        },
        enumerable: true,
        configurable: true
    });
    Photo.prototype.rotate = function () {
        this.angle = this.angle || 0;
        this.angle = this.angle + 90;
        if (this.angle === 360) {
            this.angle = null;
        }
        // Because we've rotated the image, the crop coordinates
        // need to rotate as well.
        if (this.isCropped) {
            this.crop = {
                x: 100 - this.crop.height - this.crop.y,
                y: this.crop.x,
                width: this.crop.height,
                height: this.crop.width,
            };
        }
    };
    Photo.prototype.signedUrl = function (publicId, options) {
        var queryString = $.param({ options: options });
        return "/cloudinary/images/" + publicId + "?" + queryString;
    };
    Object.defineProperty(Photo.prototype, "isCropped", {
        get: function () {
            return this.crop.width && !this.isCroppedToFullImage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Photo.prototype, "isCroppedToFullImage", {
        get: function () {
            return this.crop.width === 100 && this.crop.height === 100;
        },
        enumerable: true,
        configurable: true
    });
    Photo.prototype.meetsMinimumDimension = function (dimension) {
        return this.width >= dimension && this.height >= dimension;
    };
    return Photo;
}());
exports.default = Photo;
//# sourceMappingURL=photo.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/photos/photo.js
// module id = shBy
// module chunks = 20 21